export default __webpack_public_path__ + "static/BW-link-cover-DE-40b397a652da0a56db2a0fd407189024.jpg";